import React from "react";

const HisEdit3 = ({ color, sx }) => {
  const strokeColor = color ?? "#4C2AC6";
  const _sx = sx ?? {};

  return (
    <svg
      style={_sx}
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3125 20.0391H21.3125"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8125 3.53538C17.2103 3.13756 17.7499 2.91406 18.3125 2.91406C18.5911 2.91406 18.8669 2.96893 19.1243 3.07554C19.3817 3.18214 19.6155 3.3384 19.8125 3.53538C20.0095 3.73237 20.1657 3.96622 20.2723 4.22359C20.379 4.48096 20.4338 4.75681 20.4338 5.03538C20.4338 5.31396 20.379 5.58981 20.2723 5.84718C20.1657 6.10455 20.0095 6.3384 19.8125 6.53538L7.3125 19.0354L3.3125 20.0354L4.3125 16.0354L16.8125 3.53538Z"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default HisEdit3;
